import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { getBotFillConfig, saveBotFillConfig } from './api';
import { BotFillConfig, BotFillStage } from './types';
const key = (stage: BotFillStage) => ['admin-bot-fill-config', stage];
export const useBotFillConfig = (stage: BotFillStage) => useQuery({ queryKey: key(stage), queryFn: () => getBotFillConfig(stage) });
export function useSaveBotFillConfig(stage: BotFillStage) {
  const client = useQueryClient();
  return useMutation({ mutationFn: (input: BotFillConfig) => saveBotFillConfig(stage, input), onSuccess: () => client.invalidateQueries({ queryKey: key(stage) }) });
}
